import type { RouteRecord } from 'vite-react-ssg';

import { App } from './App';
import { getAllPosts } from './lib/blog';

export const routes: RouteRecord[] = [
  {
    path: '/',
    Component: App,
    children: [
      {
        index: true,
        lazy: async () => {
          const m = await import('./routes/Landing');
          return { Component: m.default };
        },
      },
      {
        path: 'blog',
        lazy: async () => {
          const m = await import('./routes/BlogIndex');
          return { Component: m.default };
        },
      },
      {
        path: 'blog/:slug',
        lazy: async () => {
          const m = await import('./routes/BlogPost');
          return { Component: m.default };
        },
        getStaticPaths: () => getAllPosts().map((post) => `blog/${post.slug}`),
      },
      {
        path: 'privacy',
        lazy: async () => {
          const m = await import('./routes/Privacy');
          return { Component: m.default };
        },
      },
      {
        path: 'terms',
        lazy: async () => {
          const m = await import('./routes/Terms');
          return { Component: m.default };
        },
      },
      {
        path: '404',
        lazy: async () => {
          const m = await import('./routes/NotFound');
          return { Component: m.default };
        },
      },
      {
        path: '*',
        lazy: async () => {
          const m = await import('./routes/NotFound');
          return { Component: m.default };
        },
      },
    ],
    entry: 'src/main.tsx',
  },
];
